import type { MapsLocale } from "../MapsLocale";
import type { NumberFormats } from "./types";

type FormatterCacheKey = `${NumberFormats}_${string}`;
export type FormatNumberFn = (value: number, format: NumberFormats) => string;

const formatterCache = new Map<FormatterCacheKey, Intl.NumberFormat>();

export const formatNumber = (
    value: number,
    format: NumberFormats,
    locale: MapsLocale,
): string => {
    const formatOptions: Intl.NumberFormatOptions = {};

    switch (format) {
        case "roundedNumber": {
            formatOptions.maximumFractionDigits = 1;
            break;
        }

        case "number":
            break;
    }

    const formatterCacheKey: FormatterCacheKey = `${format}_${locale.languageAndRegion}`;

    // cache the formatter because its creation is kinda expensive performance wise
    if (!formatterCache.has(formatterCacheKey)) {
        formatterCache.set(
            formatterCacheKey,
            new Intl.NumberFormat(locale, formatOptions),
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return formatterCache.get(formatterCacheKey)!.format(value);
};
